import { useTheme } from "styled-components";

import { CustomLink } from "@sso/ui/CustomLink";
import { GridItem, GridSize } from "@sso/ui/FlexBox";

interface ProfileTabItemProps {
  title: string;
  to: string;
  active: boolean;
  xsSize?: GridSize;
}

export const ProfileTabItem = ({ title, to, active, xsSize = 6 }: ProfileTabItemProps) => {
  const theme = useTheme();
  return (
    <GridItem xs={xsSize}>
      <CustomLink
        to={to}
        hovertextdecoration="none"
        padding="0.75rem"
        fontWeight="bold"
        color={active ? theme.colors.primary.main : theme.colors.grey[500]}
      >
        {title}
      </CustomLink>
    </GridItem>
  );
};
